export interface Variant {
  id: number;
  size: string;
  color: string;
  color_hex: string;
  price: number;
  stock: number;
}

export interface Category {
  id: number;
  name: string;
  slug: string;
}

export interface Product {
  id: number;
  name: string;
  slug: string;
  price: number;
  compare_price?: number;
  featured_image: string;
  is_new?: boolean;
  is_featured?: boolean;
  colors?: Array<{ name: string; hex: string }>;
  sizes?: string[];
  category: Category;
  variants: Variant[];
  images: Array<{ id: number; image: string; alt_text: string }>;
  description: string;
  brand: string;
  sku: string;
  stock: number;
  product_type?: 'pet' | 'food' | 'accessory' | 'other';
  breed?: string;
  age?: string;
  gender?: string;
  vaccinated?: boolean;
  pet_type?: string;
  weight?: string;
  flavor?: string;
}

export const DUMMY_PRODUCTS: Product[] = [
  // PETS
  {
    id: 1,
    name: "Golden Retriever Puppy",
    slug: "golden-retriever-puppy",
    price: 35000,
    compare_price: 40000,
    featured_image: "https://images.unsplash.com/photo-1552053831-71594a27632d",
    is_new: true,
    is_featured: true,
    colors: [{ name: "Golden", hex: "#dfc19b" }],
    sizes: ["Standard"],
    category: { id: 1, name: "Pets", slug: "pets" },
    variants: [
      { id: 101, size: "Standard", color: "Golden", color_hex: "#dfc19b", price: 35000, stock: 1 }
    ],
    images: [
      { id: 11, image: "https://images.unsplash.com/photo-1583511655857-d19b40a7a54e", alt_text: "Golden puppy front" }
    ],
    description: "A playful, energetic, and healthy Golden Retriever puppy. Extremely friendly, socialized with kids, and looking for a loving home.",
    brand: "Royal Pet Store",
    sku: "PET-DOG-GR01",
    stock: 1,
    product_type: "pet",
    breed: "Labrador Retriever",
    age: "2 Months",
    gender: "Male",
    vaccinated: true,
    pet_type: "Dog"
  },
  {
    id: 2,
    name: "Siberian Husky",
    slug: "siberian-husky",
    price: 45000,
    compare_price: 50000,
    featured_image: "https://images.unsplash.com/photo-1531804055935-76f44d7c3621",
    is_new: true,
    is_featured: true,
    colors: [{ name: "Grey-White", hex: "#808080" }],
    sizes: ["Standard"],
    category: { id: 1, name: "Pets", slug: "pets" },
    variants: [
      { id: 201, size: "Standard", color: "Grey-White", color_hex: "#808080", price: 45000, stock: 1 }
    ],
    images: [],
    description: "Stunning Siberian Husky puppy with bright blue eyes. Very alert, active, and fully microchipped and dewormed.",
    brand: "Royal Pet Store",
    sku: "PET-DOG-SH02",
    stock: 1,
    product_type: "pet",
    breed: "Husky",
    age: "3 Months",
    gender: "Female",
    vaccinated: true,
    pet_type: "Dog"
  },
  {
    id: 3,
    name: "Persian Kitten",
    slug: "persian-kitten",
    price: 15000,
    compare_price: 18000,
    featured_image: "https://images.unsplash.com/photo-1618826411640-d6df44dd3f7a",
    is_new: true,
    is_featured: false,
    colors: [{ name: "White", hex: "#FFFFFF" }],
    sizes: ["Standard"],
    category: { id: 1, name: "Pets", slug: "pets" },
    variants: [
      { id: 301, size: "Standard", color: "White", color_hex: "#FFFFFF", price: 15000, stock: 1 }
    ],
    images: [],
    description: "Cute, fluffy doll-faced Persian kitten. Gentle temperament, dewormed, litter trained, and loves to cuddle.",
    brand: "Royal Pet Store",
    sku: "PET-CAT-PK03",
    stock: 1,
    product_type: "pet",
    breed: "Persian",
    age: "2 Months",
    gender: "Female",
    vaccinated: false,
    pet_type: "Cat"
  },
  {
    id: 4,
    name: "British Shorthair Cat",
    slug: "british-shorthair-cat",
    price: 25000,
    compare_price: 30000,
    featured_image: "https://images.unsplash.com/photo-1573865526739-10659fec78a5",
    is_new: false,
    is_featured: true,
    colors: [{ name: "Blue", hex: "#5C6B73" }],
    sizes: ["Standard"],
    category: { id: 1, name: "Pets", slug: "pets" },
    variants: [
      { id: 401, size: "Standard", color: "Blue", color_hex: "#5C6B73", price: 25000, stock: 1 }
    ],
    images: [],
    description: "A calm and handsome British Shorthair with a plush blue coat. Loyal, quiet, and friendly companion.",
    brand: "Royal Pet Store",
    sku: "PET-CAT-BS04",
    stock: 1,
    product_type: "pet",
    breed: "British Shorthair",
    age: "6 Months",
    gender: "Male",
    vaccinated: true,
    pet_type: "Cat"
  },
  {
    id: 5,
    name: "African Grey Parrot",
    slug: "african-grey-parrot",
    price: 95000,
    compare_price: 110000,
    featured_image: "https://images.unsplash.com/photo-1522069169874-c58ec4b76be5",
    is_new: true,
    is_featured: true,
    colors: [{ name: "Grey", hex: "#7A7A7A" }],
    sizes: ["Standard"],
    category: { id: 1, name: "Pets", slug: "pets" },
    variants: [
      { id: 501, size: "Standard", color: "Grey", color_hex: "#7A7A7A", price: 95000, stock: 1 }
    ],
    images: [],
    description: "Highly intelligent African Grey Parrot. Ready for speech training, very active, healthy feather condition.",
    brand: "Royal Pet Store",
    sku: "PET-BRD-AG05",
    stock: 1,
    product_type: "pet",
    breed: "African Grey",
    age: "1 Year",
    gender: "Male",
    vaccinated: false,
    pet_type: "Bird"
  },

  // PET FOODS
  {
    id: 6,
    name: "Royal Canin Maxi Puppy Kibble",
    slug: "royal-canin-maxi-puppy-kibble",
    price: 4200,
    compare_price: 4500,
    featured_image: "https://images.unsplash.com/photo-1589924691995-400dc9ecc119",
    is_new: true,
    is_featured: false,
    colors: [{ name: "Brown", hex: "#8B4513" }],
    sizes: ["4kg"],
    category: { id: 2, name: "Pet Foods", slug: "pet-foods" },
    variants: [
      { id: 601, size: "4kg", color: "Brown", color_hex: "#8B4513", price: 4200, stock: 50 }
    ],
    images: [],
    description: "Formulated for large breed puppies. Supports immune health, healthy digestion, and long growth period.",
    brand: "Royal Canin",
    sku: "FOD-DOG-RC01",
    stock: 50,
    product_type: "food",
    pet_type: "Dog",
    weight: "4kg",
    flavor: "Chicken & Rice"
  },
  {
    id: 7,
    name: "Whiskas Wet Cat Food (Pack of 12)",
    slug: "whiskas-wet-cat-food-pack-of-12",
    price: 1800,
    compare_price: 2000,
    featured_image: "https://images.unsplash.com/photo-1611145367651-6303b46e4040",
    is_new: true,
    is_featured: false,
    colors: [{ name: "Purple", hex: "#8E44AD" }],
    sizes: ["1.2kg"],
    category: { id: 2, name: "Pet Foods", slug: "pet-foods" },
    variants: [
      { id: 701, size: "1.2kg", color: "Purple", color_hex: "#8E44AD", price: 1800, stock: 35 }
    ],
    images: [],
    description: "Nutritious wet food pouches for adult cats. Enriched with Omega 6 and Zinc for a shiny coat.",
    brand: "Whiskas",
    sku: "FOD-CAT-WK02",
    stock: 35,
    product_type: "food",
    pet_type: "Cat",
    weight: "1.2kg",
    flavor: "Salmon & Tuna in Jelly"
  },
  {
    id: 8,
    name: "Orijen Premium Adult Dog Food",
    slug: "orijen-premium-adult-dog-food",
    price: 6800,
    compare_price: 7500,
    featured_image: "https://images.unsplash.com/photo-1568640347023-a616a30bc3bd",
    is_new: true,
    is_featured: true,
    colors: [{ name: "Brown", hex: "#8B4513" }],
    sizes: ["6kg"],
    category: { id: 2, name: "Pet Foods", slug: "pet-foods" },
    variants: [
      { id: 801, size: "6kg", color: "Brown", color_hex: "#8B4513", price: 6800, stock: 20 }
    ],
    images: [],
    description: "Grain-free biologically appropriate dog food. Loaded with wild-caught fish, providing premium protein.",
    brand: "Orijen",
    sku: "FOD-DOG-OJ03",
    stock: 20,
    product_type: "food",
    pet_type: "Dog",
    weight: "6kg",
    flavor: "Six Fresh Fish"
  },
  {
    id: 9,
    name: "Me-O Gourmet Cat Kibble",
    slug: "me-o-gourmet-cat-kibble",
    price: 2200,
    compare_price: 2500,
    featured_image: "https://images.unsplash.com/photo-1514888286974-6c03e2ca1dba",
    is_new: false,
    is_featured: false,
    colors: [{ name: "Yellow", hex: "#F1C40F" }],
    sizes: ["3kg"],
    category: { id: 2, name: "Pet Foods", slug: "pet-foods" },
    variants: [
      { id: 901, size: "3kg", color: "Yellow", color_hex: "#F1C40F", price: 2200, stock: 80 }
    ],
    images: [],
    description: "Complete and balanced dry cat food. Highly digestible, supports vision health and urinary tract functions.",
    brand: "Me-O",
    sku: "FOD-CAT-MO04",
    stock: 80,
    product_type: "food",
    pet_type: "Cat",
    weight: "3kg",
    flavor: "Tuna & Seafood Mix"
  },

  // PET ACCESSORIES
  {
    id: 10,
    name: "Orthopedic Memory Foam Pet Bed",
    slug: "orthopedic-memory-foam-pet-bed",
    price: 3500,
    compare_price: 4500,
    featured_image: "https://images.unsplash.com/photo-1596492784531-6e6eb5ea9993",
    is_new: false,
    is_featured: true,
    colors: [
      { name: "Grey", hex: "#808080" },
      { name: "Brown", hex: "#8B4513" }
    ],
    sizes: ["M", "L", "XL"],
    category: { id: 3, name: "Pet Accessories", slug: "pet-accessories" },
    variants: [
      { id: 1001, size: "M", color: "Grey", color_hex: "#808080", price: 3000, stock: 15 },
      { id: 1002, size: "L", color: "Grey", color_hex: "#808080", price: 3500, stock: 20 },
      { id: 1003, size: "XL", color: "Grey", color_hex: "#808080", price: 4200, stock: 10 },
      { id: 1004, size: "M", color: "Brown", color_hex: "#8B4513", price: 3000, stock: 15 },
      { id: 1005, size: "L", color: "Brown", color_hex: "#8B4513", price: 3500, stock: 18 }
    ],
    images: [],
    description: "Ultra-soft memory foam pet bed designed to relieve joint pain and promote restful sleep for your furry friends.",
    brand: "CozyPaws",
    sku: "ACC-BED-OM01",
    stock: 78,
    product_type: "accessory",
    pet_type: "Dog & Cat"
  },
  {
    id: 11,
    name: "Handcrafted Leather Dog Collar",
    slug: "handcrafted-leather-dog-collar",
    price: 1500,
    compare_price: 2000,
    featured_image: "https://images.unsplash.com/photo-1576201836106-db1758fd1c97",
    is_new: false,
    is_featured: true,
    colors: [
      { name: "Tan", hex: "#C8A97E" },
      { name: "Dark Red", hex: "#8B0000" }
    ],
    sizes: ["S", "M", "L"],
    category: { id: 3, name: "Pet Accessories", slug: "pet-accessories" },
    variants: [
      { id: 1101, size: "S", color: "Tan", color_hex: "#C8A97E", price: 1200, stock: 30 },
      { id: 1102, size: "M", color: "Tan", color_hex: "#C8A97E", price: 1500, stock: 25 },
      { id: 1103, size: "L", color: "Tan", color_hex: "#C8A97E", price: 1800, stock: 20 }
    ],
    images: [],
    description: "Durable and stylish genuine leather dog collar with solid brass hardware. Weather-resistant and comfortable.",
    brand: "PawsGear",
    sku: "ACC-COL-HL02",
    stock: 75,
    product_type: "accessory",
    pet_type: "Dog"
  },
  {
    id: 12,
    name: "Interactive Cat Toy Wand",
    slug: "interactive-cat-toy-wand",
    price: 850,
    compare_price: 1000,
    featured_image: "https://images.unsplash.com/photo-1548767797-d8c844163c4c",
    is_new: false,
    is_featured: false,
    colors: [{ name: "Rainbow", hex: "#FF00FF" }],
    sizes: ["One Size"],
    category: { id: 3, name: "Pet Accessories", slug: "pet-accessories" },
    variants: [
      { id: 1201, size: "One Size", color: "Rainbow", color_hex: "#FF00FF", price: 850, stock: 100 }
    ],
    images: [],
    description: "Interactive feather toy wand to keep your cat active and entertained. Safe non-toxic materials.",
    brand: "PlayPaws",
    sku: "ACC-TOY-CW03",
    stock: 100,
    product_type: "accessory",
    pet_type: "Cat"
  }
];

export function handleMockRequest(url: string, params: any = {}) {
  let path = url;
  if (path.startsWith('http://') || path.startsWith('https://')) {
    try {
      const parsed = new URL(path);
      path = parsed.pathname;
    } catch (e) {}
  }
  
  path = path.replace(/^\/?api/, '');
  if (!path.startsWith('/')) {
    path = '/' + path;
  }

  if (path === '/products/new-arrivals') {
    return DUMMY_PRODUCTS.filter(p => p.is_new);
  }
  if (path === '/products/featured') {
    return DUMMY_PRODUCTS.filter(p => p.is_featured);
  }
  if (path.startsWith('/products/')) {
    const parts = path.split('/');
    const slug = parts[2];
    const product = DUMMY_PRODUCTS.find(p => p.slug === slug);
    if (product) {
      const related = DUMMY_PRODUCTS.filter(p => p.category.slug === product.category.slug && p.id !== product.id).slice(0, 4);
      return { product, related };
    }
  }
  if (path === '/products') {
    let filtered = [...DUMMY_PRODUCTS];
    if (params.category) {
      filtered = filtered.filter(p => p.category.slug === params.category);
    }
    if (params.is_new) {
      filtered = filtered.filter(p => p.is_new);
    }
    if (params.search) {
      const q = String(params.search).toLowerCase();
      filtered = filtered.filter(p => p.name.toLowerCase().includes(q) || p.description.toLowerCase().includes(q));
    }
    if (params.min_price) {
      filtered = filtered.filter(p => p.price >= Number(params.min_price));
    }
    if (params.max_price) {
      filtered = filtered.filter(p => p.price <= Number(params.max_price));
    }
    
    if (params.sort_by === 'price_asc') {
      filtered.sort((a, b) => a.price - b.price);
    } else if (params.sort_by === 'price_desc') {
      filtered.sort((a, b) => b.price - a.price);
    } else if (params.sort_by === 'newest') {
      filtered.sort((a, b) => (b.is_new ? 1 : 0) - (a.is_new ? 1 : 0));
    }

    return {
      data: filtered,
      total: filtered.length,
      current_page: 1,
      last_page: 1
    };
  }
  if (path.startsWith('/categories/')) {
    const slug = path.split('/')[2];
    const catNames: Record<string, string> = {
      'pets': "Pets",
      'pet-foods': "Pet Foods",
      'pet-accessories': "Pet Accessories"
    };
    if (catNames[slug]) {
      return { id: 999, name: catNames[slug], slug };
    }
  }
  if (path === '/promotions') {
    return [
      { id: 1, text: "FREE DELIVERIES ON ORDERS ABOVE RS. 10,000" },
      { id: 2, text: "HAPPY & HEALTHY COMPANIONS FOR ADOPTION" },
      { id: 3, text: "CERTIFIED VETERINARY HEALTH INSPECTIONS" }
    ];
  }
  return null;
}
